import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=310b3391&scoped=true&"
import script from "./FlightDetails.vue?vue&type=script&lang=js&"
export * from "./FlightDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b3391",
  null
  
)

export default component.exports